import React, { useMemo, useState } from 'react'
import { useAtom } from 'jotai/react'

import { SUPPORT_PREFERRED_EXPLORER } from '@/constants/settings'
import { cn } from '@/lib/utils'
import { preferredExplorerAtom } from '@/stores/settings'

import { Grid } from '../common/Box'
import { Button, SelectButton } from '../common/Button'
import DropdownMenu from '../common/DropdownMenu'
import { OrbitronText } from '../common/Text'

const PreferredExplorerSelect: React.FC = () => {
  const [open, setOpen] = useState(false)
  const [preferredExplorer, setPreferredExplorer] = useAtom(
    preferredExplorerAtom
  )

  const preferredExplorerSelected = useMemo(
    () =>
      SUPPORT_PREFERRED_EXPLORER.find(({ url }) => url === preferredExplorer)!,
    [preferredExplorer]
  )

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      secondary
      trigger={{
        asChild: true,
        children: (
          <SelectButton
            variant="secondary"
            className="justify-between xl:min-w-[200px]"
          >
            <OrbitronText className="font-Orbitron text-xs font-bold xl:text-base">
              {preferredExplorerSelected.name}
            </OrbitronText>
          </SelectButton>
        )
      }}
      content={{ align: 'end', className: 'w-auto mx-0' }}
    >
      <Grid className="gap-1">
        {SUPPORT_PREFERRED_EXPLORER.map(({ name, url }) => (
          <Button
            key={url}
            border={false}
            size="md"
            link
            className={cn(
              'justify-start !px-0 py-2 font-Orbitron hover:text-primary',
              preferredExplorerSelected.url !== url && 'text-primary-foreground'
            )}
            onClick={() => {
              setPreferredExplorer(url)
              setOpen(false)
            }}
          >
            {name}
          </Button>
        ))}
      </Grid>
    </DropdownMenu>
  )
}

export default PreferredExplorerSelect
